<template>
  <v-tour
    :callbacks="callbacks"
    :name="tourName"
    :steps="steps"
  >
    <template slot-scope="tour">
      <transition name="fade">
        <v-step
          v-if="tour.steps[tour.currentStep]"
          :key="tour.currentStep"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
          :next-step="tour.nextStep"
          :previous-step="tour.previousStep"
          :skip="tour.skip"
          :step="tour.steps[tour.currentStep]"
          :stop="tour.stop"
        >
          <template #header>
            <StepHeaderClose @close="tour.skip">
              <template #title>
                {{ tour.steps[tour.currentStep].title }}
              </template>
            </StepHeaderClose>
          </template>
          <div
            slot="actions"
            class="actions__wrapper"
          >
            <div class="actions__steps-counter">
              {{ tour.currentStep + 1 }} of {{ tour.steps.length }}
            </div>
            <div class="actions__buttons">
              <template v-if="tour.currentStep === steps.length - 1">
                <gl-button
                  class="btn-finish"
                  dark
                  full
                  title="Finish"
                  @click="tour.finish"
                />
              </template>
              <template v-else>
                <gl-button
                  class="btn-skip"
                  dark
                  full
                  :title="'Skip'"
                  @click="tour.skip"
                />
                <gl-button
                  dark
                  full
                  :title="'Next'"
                  @click="tour.nextStep"
                />
              </template>
            </div>
          </div>
        </v-step>
      </transition>
    </template>
  </v-tour>
</template>

<script>
// components
import StepHeaderClose from '@/pages/report/components/onboarding/StepHeaderClose'
import GlButton from '@/components/gl-button'

export default {
  name: 'TourStepsTemplate',
  components: {
    StepHeaderClose,
    GlButton,
  },

  props: {
    tourName: {
      type: String,
      default: '',
      required: true,
    },
    callbacks: {
      type: Object,
      default: () => ({}),
    },
    steps: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
